export function getAvailableLuxPlusInclusionsForMembers(
  luxPlusInclusionsByTier: App.LuxPlusInclusionsByTier | undefined,
  inclusionsViewableLuxPlusTier: App.MembershipSubscriptionTier,
  hasLuxPlusOrSubscriptionInCart: boolean,
): Array<App.PackageInclusion> {
  if (!hasLuxPlusOrSubscriptionInCart || !luxPlusInclusionsByTier) {
    return []
  }

  return luxPlusInclusionsByTier[inclusionsViewableLuxPlusTier] || []
}

export function buildEvergreenPackageInclusions(
  evergreenInclusions: Array<App.EvergreenInclusion>,
): Array<App.PackageInclusion> {
  return evergreenInclusions.map((inclusion) => ({
    id: inclusion.id,
    description: inclusion.description,
    symbol: 'key',
    isHighlighted: true,
  }))
}
